import { render, staticRenderFns } from "./EditarArea.vue?vue&type=template&id=419e4bfc&"
import script from "./EditarArea.vue?vue&type=script&lang=js&"
export * from "./EditarArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports